<template>
    <div id="back-forward-buttons" class="lb-btn-container">
        <div class="red-pill-button-of-hate go-next btn-print-result" v-on:click="goForward">Напечатать результат</div>
    </div>
</template>

<script>
    export default {
        name: "RightLowerBarPrintResult",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            stepsOrder(){
                return this.$store.state.UI.stepsChain[this.version].stepsOrder;
            },
            adjacentSteps() {
                return this.stepsOrder[this.activeStep]
            }
        },
        methods: {
            async goForward() {
                await this.$router.push({name: this.adjacentSteps.next, query: this.$store.state.route.query}).catch(err=>{});
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .btn-print-result {
            font-size: 14px;
        }
    }

    @media screen and (min-height: 800px) {
        .btn-print-result {
            font-size: 16px;
        }
    }

    .btn-print-result {
        padding: 10px 25px 8px 25px;
    }
</style>
